import {inject, Service} from '@angular/core';
import {Title} from '@angular/platform-browser';
import {IAppConfig} from '../../core/config/app-config.interface';
import {PROJECT_CONFIG} from 'src/app/project.config';

/**
 * PageTitleService
 *
 * Wraps Angulars Title Service, but uses our app config for consistency page title format
 */

@Service()
export class PageTitleService {
  private readonly config = inject<IAppConfig>(PROJECT_CONFIG);
  private readonly titleService = inject(Title);


  /**
   * Sets the browser title as `<title> - <app name>`.  Pages with nothing meaningful to show
   * pass nothing and get the bare app name.
   */
  setTitle(title?: string | number | null) {
    const prefix = title === null || title === undefined || title === '' ? '' : title + ' - ';

    this.titleService.setTitle(prefix + this.config.appName);
  }
}
